__turbopack_context__.v({
  "card": "ArticleDetail-module__nP-b3q__card",
  "cardTitle": "ArticleDetail-module__nP-b3q__cardTitle",
  "container": "ArticleDetail-module__nP-b3q__container",
  "dek": "ArticleDetail-module__nP-b3q__dek",
  "grid": "ArticleDetail-module__nP-b3q__grid",
  "h1": "ArticleDetail-module__nP-b3q__h1",
  "heroBackground": "ArticleDetail-module__nP-b3q__heroBackground",
  "heroBanner": "ArticleDetail-module__nP-b3q__heroBanner",
  "heroContainer": "ArticleDetail-module__nP-b3q__heroContainer",
  "heroContent": "ArticleDetail-module__nP-b3q__heroContent",
  "heroImage": "ArticleDetail-module__nP-b3q__heroImage",
  "heroOverlay": "ArticleDetail-module__nP-b3q__heroOverlay",
  "metaBar": "ArticleDetail-module__nP-b3q__metaBar",
  "prose": "ArticleDetail-module__nP-b3q__prose",
  "sidebar": "ArticleDetail-module__nP-b3q__sidebar",
  "slowZoom": "ArticleDetail-module__nP-b3q__slowZoom",
  "tag": "ArticleDetail-module__nP-b3q__tag",
  "tagList": "ArticleDetail-module__nP-b3q__tagList",
  "tagPill": "ArticleDetail-module__nP-b3q__tagPill",
  "tagRow": "ArticleDetail-module__nP-b3q__tagRow",
  "tertiaryColumn": "ArticleDetail-module__nP-b3q__tertiaryColumn",
});
